import { getMainEnv } from './getMainEnv';

export function getIconsUrl(): string {
  const env = getMainEnv();

  return env?.VITE_ICONS_URL ?? '';
}
